export const COMPANY_CATEGORIES = [
  { parent: true,  value: "IAB1",    title: "Arts & Entertainment" },
  { parent: false, value: "IAB1-1",  title: "Books & Literature" },
  { parent: false, value: "IAB1-2",  title: "Celebrity Fan/Gossip" },
  { parent: false, value: "IAB1-3",  title: "Fine Art" },
  { parent: false, value: "IAB1-4",  title: "Humor" },
  { parent: false, value: "IAB1-5",  title: "Movies" },
  { parent: false, value: "IAB1-6",  title: "Music" },
  { parent: false, value: "IAB1-7",  title: "Television" },
  { parent: true,  value: "IAB2",    title: "Automotive" },
  { parent: false, value: "IAB2-1",  title: "Auto Parts" },
  { parent: false, value: "IAB2-2",  title: "Auto Repair" },
  { parent: false, value: "IAB2-3",  title: "Buying/Selling Cars" },
  { parent: false, value: "IAB2-4",  title: "Car Culture" },
  { parent: false, value: "IAB2-5",  title: "Certified Pre-Owned" },
  { parent: false, value: "IAB2-6",  title: "Convertible" },
  { parent: false, value: "IAB2-7",  title: "Coupe" },
  { parent: false, value: "IAB2-8",  title: "Crossover" },
  { parent: false, value: "IAB2-9",  title: "Diesel" },
  { parent: false, value: "IAB2-10", title: "Electric Vehicle" },
  { parent: false, value: "IAB2-11", title: "Hatchback" },
  { parent: false, value: "IAB2-12", title: "Hybrid" },
  { parent: false, value: "IAB2-13", title: "Luxury" },
  { parent: false, value: "IAB2-14", title: "MiniVan" },
  { parent: false, value: "IAB2-15", title: "Mororcycles" },
  { parent: false, value: "IAB2-16", title: "Off-Road Vehicles" },
  { parent: false, value: "IAB2-17", title: "Performance Vehicles" },
  { parent: false, value: "IAB2-18", title: "Pickup" },
  { parent: false, value: "IAB2-19", title: "Road-Side Assistance" },
  { parent: false, value: "IAB2-20", title: "Sedan" },
  { parent: false, value: "IAB2-21", title: "Trucks & Accessories" },
  { parent: false, value: "IAB2-22", title: "Vintage Cars" },
  { parent: false, value: "IAB2-23", title: "Wagon" },
  { parent: true,  value: "IAB3",    title: "Business" },
  { parent: false, value: "IAB3-1",  title: "Advertising" },
  { parent: false, value: "IAB3-2",  title: "Agriculture" },
  { parent: false, value: "IAB3-3",  title: "Biotech/Biomedical" },
  { parent: false, value: "IAB3-4",  title: "Business Software" },
  { parent: false, value: "IAB3-5",  title: "Construction" },
  { parent: false, value: "IAB3-6",  title: "Forestry" },
  { parent: false, value: "IAB3-7",  title: "Government" },
  { parent: false, value: "IAB3-8",  title: "Green Solutions" },
  { parent: false, value: "IAB3-9",  title: "Human Resources" },
  { parent: false, value: "IAB3-10", title: "Logistics" },
  { parent: false, value: "IAB3-11", title: "Marketing" },
  { parent: false, value: "IAB3-12", title: "Metals" },
  { parent: true,  value: "IAB4",    title: "Careers" },
  { parent: false, value: "IAB4-1",  title: "Career Planning" },
  { parent: false, value: "IAB4-2",  title: "College" },
  { parent: false, value: "IAB4-3",  title: "Financial Aid" },
  { parent: false, value: "IAB4-4",  title: "Job Fairs" },
  { parent: false, value: "IAB4-5",  title: "Job Search" },
  { parent: false, value: "IAB4-6",  title: "Resume Writing/Advice" },
  { parent: false, value: "IAB4-7",  title: "Nursing" },
  { parent: false, value: "IAB4-8",  title: "Scholarships" },
  { parent: false, value: "IAB4-9",  title: "Telecommuting" },
  { parent: false, value: "IAB4-10", title: "U.S. Military" },
  { parent: false, value: "IAB4-11", title: "Career Advice" },
  { parent: true,  value: "IAB5",    title: "Education" },
  { parent: false, value: "IAB5-1",  title: "7-12 Education" },
  { parent: false, value: "IAB5-2",  title: "Adult Education" },
  { parent: false, value: "IAB5-3",  title: "Art History" },
  { parent: false, value: "IAB5-4",  title: "College Administration" },
  { parent: false, value: "IAB5-5",  title: "College Life" },
  { parent: false, value: "IAB5-6",  title: "Distance Learning" },
  { parent: false, value: "IAB5-7",  title: "English as a 2nd Language" },
  { parent: false, value: "IAB5-8",  title: "Language Learning" },
  { parent: false, value: "IAB5-9",  title: "Graduate School" },
  { parent: false, value: "IAB5-10", title: "Homeschooling" },
  { parent: false, value: "IAB5-11", title: "Homework/Study Tips" },
  { parent: false, value: "IAB5-12", title: "K-6 Educators" },
  { parent: false, value: "IAB5-13", title: "Private School" },
  { parent: false, value: "IAB5-14", title: "Special Education" },
  { parent: false, value: "IAB5-15", title: "Studying Business" },
  { parent: true,  value: "IAB6",    title: "Family & Parenting" },
  { parent: false, value: "IAB6-1",  title: "Adoption" },
  { parent: false, value: "IAB6-2",  title: "Babies & Toddlers" },
  { parent: false, value: "IAB6-3",  title: "Daycare/Pre School" },
  { parent: false, value: "IAB6-4",  title: "Family Internet" },
  { parent: false, value: "IAB6-5",  title: "Parenting - K-6 Kids" },
  { parent: false, value: "IAB6-6",  title: "Parenting teens" },
  { parent: false, value: "IAB6-7",  title: "Pregnancy" },
  { parent: false, value: "IAB6-8",  title: "Special Needs Kids" },
  { parent: false, value: "IAB6-9",  title: "Eldercare" },
  { parent: true,  value: "IAB7",    title: "Health & Fitness" },
  { parent: false, value: "IAB7-1",  title: "Exercise" },
  { parent: false, value: "IAB7-2",  title: "A.D.D." },
  { parent: false, value: "IAB7-3",  title: "AIDS/HIV" },
  { parent: false, value: "IAB7-4",  title: "Allergies" },
  { parent: false, value: "IAB7-5",  title: "Alternative Medicine" },
  { parent: false, value: "IAB7-6",  title: "Arthritis" },
  { parent: false, value: "IAB7-7",  title: "Asthma" },
  { parent: false, value: "IAB7-8",  title: "Autism/PDD" },
  { parent: false, value: "IAB7-9",  title: "Bipolar Disorder" },
  { parent: false, value: "IAB7-10", title: "Brain Tumor" },
  { parent: false, value: "IAB7-11", title: "Cancer" },
  { parent: false, value: "IAB7-12", title: "Cholesterol" },
  { parent: false, value: "IAB7-13", title: "Chronic Fatigue Syndrome" },
  { parent: false, value: "IAB7-14", title: "Chronic Pain" },
  { parent: false, value: "IAB7-15", title: "Cold & Flu" },
  { parent: false, value: "IAB7-16", title: "Deafness" },
  { parent: false, value: "IAB7-17", title: "Dental Care" },
  { parent: false, value: "IAB7-18", title: "Depression" },
  { parent: false, value: "IAB7-19", title: "Dermatology" },
  { parent: false, value: "IAB7-20", title: "Diabetes" },
  { parent: false, value: "IAB7-21", title: "Epilepsy" },
  { parent: false, value: "IAB7-22", title: "GERD/Acid Reflux" },
  { parent: false, value: "IAB7-23", title: "Headaches/Migraines" },
  { parent: false, value: "IAB7-24", title: "Heart Disease" },
  { parent: false, value: "IAB7-25", title: "Herbs for Health" },
  { parent: false, value: "IAB7-26", title: "Holistic Healing" },
  { parent: false, value: "IAB7-27", title: "IBS/Crohn's Disease" },
  { parent: false, value: "IAB7-28", title: "Incest/Abuse Support" },
  { parent: false, value: "IAB7-29", title: "Incontinence" },
  { parent: false, value: "IAB7-30", title: "Infertility" },
  { parent: false, value: "IAB7-31", title: "Men's Health" },
  { parent: false, value: "IAB7-32", title: "Nutrition" },
  { parent: false, value: "IAB7-33", title: "Orthopedics" },
  { parent: false, value: "IAB7-34", title: "Panic/Anxiety Disorders" },
  { parent: false, value: "IAB7-35", title: "Pediatrics" },
  { parent: false, value: "IAB7-36", title: "Physical Therapy" },
  { parent: false, value: "IAB7-37", title: "Psychology/Psychiatry" },
  { parent: false, value: "IAB7-38", title: "Senior Health" },
  { parent: false, value: "IAB7-39", title: "Sexuality" },
  { parent: false, value: "IAB7-40", title: "Sleep Disorders" },
  { parent: false, value: "IAB7-41", title: "Smoking Cessation" },
  { parent: false, value: "IAB7-42", title: "Substance Abuse" },
  { parent: false, value: "IAB7-43", title: "Thyroid Disease" },
  { parent: false, value: "IAB7-44", title: "Weight Loss" },
  { parent: false, value: "IAB7-45", title: "Women's Health" },
  { parent: true,  value: "IAB8",    title: "Food & Drink" },
  { parent: false, value: "IAB8-1",  title: "American Cuisine" },
  { parent: false, value: "IAB8-2",  title: "Barbecues & Grilling" },
  { parent: false, value: "IAB8-3",  title: "Cajun/Creole" },
  { parent: false, value: "IAB8-4",  title: "Chinese Cuisine" },
  { parent: false, value: "IAB8-5",  title: "Cocktails/Beer" },
  { parent: false, value: "IAB8-6",  title: "Coffee/Tea" },
  { parent: false, value: "IAB8-7",  title: "Cuisine-Specific" },
  { parent: false, value: "IAB8-8",  title: "Desserts & Baking" },
  { parent: false, value: "IAB8-9",  title: "Dining Out" },
  { parent: false, value: "IAB8-10", title: "Food Allergies" },
  { parent: false, value: "IAB8-11", title: "French Cuisine" },
  { parent: false, value: "IAB8-12", title: "Health/Lowfat Cooking" },
  { parent: false, value: "IAB8-13", title: "Italian Cuisine" },
  { parent: false, value: "IAB8-14", title: "Japanese Cuisine" },
  { parent: false, value: "IAB8-15", title: "Mexican Cuisine" },
  { parent: false, value: "IAB8-16", title: "Vegan" },
  { parent: false, value: "IAB8-17", title: "Vegetarian" },
  { parent: false, value: "IAB8-18", title: "Wine" },
  { parent: true,  value: "IAB9",    title: "Hobbies & Interests" },
  { parent: false, value: "IAB9-1",  title: "Art/Technology" },
  { parent: false, value: "IAB9-2",  title: "Arts & Crafts" },
  { parent: false, value: "IAB9-3",  title: "Beadwork" },
  { parent: false, value: "IAB9-4",  title: "Birdwatching" },
  { parent: false, value: "IAB9-5",  title: "Board Games/Puzzles" },
  { parent: false, value: "IAB9-6",  title: "Candle & Soap Making" },
  { parent: false, value: "IAB9-7",  title: "Card Games" },
  { parent: false, value: "IAB9-8",  title: "Chess" },
  { parent: false, value: "IAB9-9",  title: "Cigars" },
  { parent: false, value: "IAB9-10", title: "Collecting" },
  { parent: false, value: "IAB9-11", title: "Comic Books" },
  { parent: false, value: "IAB9-12", title: "Drawing/Sketching" },
  { parent: false, value: "IAB9-13", title: "Freelance Writing" },
  { parent: false, value: "IAB9-14", title: "Genealogy" },
  { parent: false, value: "IAB9-15", title: "Getting Published" },
  { parent: false, value: "IAB9-16", title: "Guitar" },
  { parent: false, value: "IAB9-17", title: "Home Recording" },
  { parent: false, value: "IAB9-18", title: "Investors & Patents" },
  { parent: false, value: "IAB9-19", title: "Jewelry Making" },
  { parent: false, value: "IAB9-20", title: "Magic & Illusion" },
  { parent: false, value: "IAB9-21", title: "Needlework" },
  { parent: false, value: "IAB9-22", title: "Painting" },
  { parent: false, value: "IAB9-23", title: "Photography" },
  { parent: false, value: "IAB9-24", title: "Radio" },
  { parent: false, value: "IAB9-25", title: "Roleplaying Games" },
  { parent: false, value: "IAB9-26", title: "Sci-Fi & Fantasy" },
  { parent: false, value: "IAB9-27", title: "Scrapbooking" },
  { parent: false, value: "IAB9-28", title: "Screenwriting" },
  { parent: false, value: "IAB9-29", title: "Stamps & Coins" },
  { parent: false, value: "IAB9-30", title: "Video & Computer Games" },
  { parent: false, value: "IAB9-31", title: "Woodworking" },
  { parent: true,  value: "IAB10",   title: "Home & Garden" },
  { parent: false, value: "IAB10-1", title: "Appliances" },
  { parent: false, value: "IAB10-2", title: "Entertaining" },
  { parent: false, value: "IAB10-3", title: "Environmental Safety" },
  { parent: false, value: "IAB10-4", title: "Gardening" },
  { parent: false, value: "IAB10-5", title: "Home Repair" },
  { parent: false, value: "IAB10-6", title: "Home Theater" },
  { parent: false, value: "IAB10-7", title: "Interior Decorating" },
  { parent: false, value: "IAB10-8", title: "Landscaping" },
  { parent: false, value: "IAB10-9", title: "Remodeling & Construction" },
  { parent: true,  value: "IAB11",   title: "Law, Gov't & Politics" },
  { parent: false, value: "IAB11-1", title: "Immigration" },
  { parent: false, value: "IAB11-2", title: "Legal Issues" },
  { parent: false, value: "IAB11-3", title: "U.S. Government Resources" },
  { parent: false, value: "IAB11-4", title: "Politics" },
  { parent: false, value: "IAB11-5", title: "Commentary" },
  { parent: true,  value: "IAB12",   title: "News" },
  { parent: false, value: "IAB12-1", title: "International News" },
  { parent: false, value: "IAB12-2", title: "National News" },
  { parent: false, value: "IAB12-3", title: "Local News" },
  { parent: true,  value: "IAB13",   title: "Personal Finance" },
  { parent: false, value: "IAB13-1", title: "Beginning Investing" },
  { parent: false, value: "IAB13-2", title: "Credit/Debt & Loans" },
  { parent: false, value: "IAB13-3", title: "Financial News" },
  { parent: false, value: "IAB13-4", title: "Financial Planning" },
  { parent: false, value: "IAB13-5", title: "Hedge Fund" },
  { parent: false, value: "IAB13-6", title: "Insurance" },
  { parent: false, value: "IAB13-7", title: "Investing" },
  { parent: false, value: "IAB13-8", title: "Mutual Funds" },
  { parent: false, value: "IAB13-9", title: "Options" },
  { parent: false, value: "IAB13-10", title: "Retirement Planning" },
  { parent: false, value: "IAB13-11", title: "Stocks" },
  { parent: false, value: "IAB13-12", title: "Tax Planning" },
  { parent: true,  value: "IAB14",   title: "Society" },
  { parent: false, value: "IAB14-1", title: "Dating" },
  { parent: false, value: "IAB14-2", title: "Divorce Support" },
  { parent: false, value: "IAB14-3", title: "Gay Life" },
  { parent: false, value: "IAB14-4", title: "Marriage" },
  { parent: false, value: "IAB14-5", title: "Senior Living" },
  { parent: false, value: "IAB14-6", title: "Teens" },
  { parent: false, value: "IAB14-7", title: "Weddings" },
  { parent: false, value: "IAB14-8", title: "Ethnic Specific" },
  { parent: true,  value: "IAB15",   title: "Science" },
  { parent: false, value: "IAB15-1", title: "Astrology" },
  { parent: false, value: "IAB15-2", title: "Biology" },
  { parent: false, value: "IAB15-3", title: "Chemistry" },
  { parent: false, value: "IAB15-4", title: "Geology" },
  { parent: false, value: "IAB15-5", title: "Paranormal Phenomena" },
  { parent: false, value: "IAB15-6", title: "Physics" },
  { parent: false, value: "IAB15-7", title: "Space/Astronomy" },
  { parent: false, value: "IAB15-8", title: "Geography" },
  { parent: false, value: "IAB15-9", title: "Botany" },
  { parent: false, value: "IAB15-10", title: "Weather" },
  { parent: true,  value: "IAB16",   title: "Pets" },
  { parent: false, value: "IAB16-1", title: "Aquariums" },
  { parent: false, value: "IAB16-2", title: "Birds" },
  { parent: false, value: "IAB16-3", title: "Cats" },
  { parent: false, value: "IAB16-4", title: "Dogs" },
  { parent: false, value: "IAB16-5", title: "Large Animals" },
  { parent: false, value: "IAB16-6", title: "Reptiles" },
  { parent: false, value: "IAB16-7", title: "Veterinary Medicine" },
  { parent: true,  value: "IAB17",   title: "Sports" },
  { parent: false, value: "IAB17-1", title: "Auto Racing" },
  { parent: false, value: "IAB17-2", title: "Baseball" },
  { parent: false, value: "IAB17-3", title: "Bicycling" },
  { parent: false, value: "IAB17-4", title: "Bodybuilding" },
  { parent: false, value: "IAB17-5", title: "Boxing" },
  { parent: false, value: "IAB17-6", title: "Canoeing/Kayaking" },
  { parent: false, value: "IAB17-7", title: "Cheerleading" },
  { parent: false, value: "IAB17-8", title: "Climbing" },
  { parent: false, value: "IAB17-9", title: "Cricket" },
  { parent: false, value: "IAB17-10", title: "Figure Skating" },
  { parent: false, value: "IAB17-11", title: "Fly Fishing" },
  { parent: false, value: "IAB17-12", title: "Football" },
  { parent: false, value: "IAB17-13", title: "Freshwater Fishing" },
  { parent: false, value: "IAB17-14", title: "Game & Fish" },
  { parent: false, value: "IAB17-15", title: "Golf" },
  { parent: false, value: "IAB17-16", title: "Horse Racing" },
  { parent: false, value: "IAB17-17", title: "Horses" },
  { parent: false, value: "IAB17-18", title: "Hunting/Shooting" },
  { parent: false, value: "IAB17-19", title: "Inline Skating" },
  { parent: false, value: "IAB17-20", title: "Martial Arts" },
  { parent: false, value: "IAB17-21", title: "Mountain Biking" },
  { parent: false, value: "IAB17-22", title: "NASCAR Racing" },
  { parent: false, value: "IAB17-23", title: "Olympics" },
  { parent: false, value: "IAB17-24", title: "Paintball" },
  { parent: false, value: "IAB17-25", title: "Power & Motorcycles" },
  { parent: false, value: "IAB17-26", title: "Pro Basketball" },
  { parent: false, value: "IAB17-27", title: "Pro Ice Hockey" },
  { parent: false, value: "IAB17-28", title: "Rodeo" },
  { parent: false, value: "IAB17-29", title: "Rugby" },
  { parent: false, value: "IAB17-30", title: "Running/Jogging" },
  { parent: false, value: "IAB17-31", title: "Sailing" },
  { parent: false, value: "IAB17-32", title: "Saltwater Fishing" },
  { parent: false, value: "IAB17-33", title: "Scuba Diving" },
  { parent: false, value: "IAB17-34", title: "Skateboarding" },
  { parent: false, value: "IAB17-35", title: "Skiing" },
  { parent: false, value: "IAB17-36", title: "Snowboarding" },
  { parent: false, value: "IAB17-37", title: "Surfing/Bodyboarding" },
  { parent: false, value: "IAB17-38", title: "Swimming" },
  { parent: false, value: "IAB17-39", title: "Table Tennis/Ping-Pong" },
  { parent: false, value: "IAB17-40", title: "Tennis" },
  { parent: false, value: "IAB17-41", title: "Volleyball" },
  { parent: false, value: "IAB17-42", title: "Walking" },
  { parent: false, value: "IAB17-43", title: "Waterski/Wakeboard" },
  { parent: false, value: "IAB17-44", title: "World Soccer" },
  { parent: true,  value: "IAB18",   title: "Style & Fashion" },
  { parent: false, value: "IAB18-1", title: "Beauty" },
  { parent: false, value: "IAB18-2", title: "Body Art" },
  { parent: false, value: "IAB18-3", title: "Fashion" },
  { parent: false, value: "IAB18-4", title: "Jewelry" },
  { parent: false, value: "IAB18-5", title: "Clothing" },
  { parent: false, value: "IAB18-6", title: "Accessories" },
  { parent: true,  value: "IAB19",   title: "Technology & Computing" },
  { parent: false, value: "IAB19-1", title: "3-D Graphics" },
  { parent: false, value: "IAB19-2", title: "Animation" },
  { parent: false, value: "IAB19-3", title: "Antivirus Software" },
  { parent: false, value: "IAB19-4", title: "C/C++" },
  { parent: false, value: "IAB19-5", title: "Cameras & Camcorders" },
  { parent: false, value: "IAB19-6", title: "Cell Phones" },
  { parent: false, value: "IAB19-7", title: "Computer Certification" },
  { parent: false, value: "IAB19-8", title: "Computer Networking" },
  { parent: false, value: "IAB19-9", title: "Computer Peripherals" },
  { parent: false, value: "IAB19-10", title: "Computer Reviews" },
  { parent: false, value: "IAB19-11", title: "Data Centers" },
  { parent: false, value: "IAB19-12", title: "Databases" },
  { parent: false, value: "IAB19-13", title: "Desktop Publishing" },
  { parent: false, value: "IAB19-14", title: "Desktop Video" },
  { parent: false, value: "IAB19-15", title: "Email" },
  { parent: false, value: "IAB19-16", title: "Graphics Software" },
  { parent: false, value: "IAB19-17", title: "Home Video/DVD" },
  { parent: false, value: "IAB19-18", title: "Internet Technology" },
  { parent: false, value: "IAB19-19", title: "Java" },
  { parent: false, value: "IAB19-20", title: "JavaScript" },
  { parent: false, value: "IAB19-21", title: "Mac Support" },
  { parent: false, value: "IAB19-22", title: "MP3/MIDI" },
  { parent: false, value: "IAB19-23", title: "Net Conferencing" },
  { parent: false, value: "IAB19-24", title: "Net for Beginners" },
  { parent: false, value: "IAB19-25", title: "Network Security" },
  { parent: false, value: "IAB19-26", title: "Palmtops/PDAs" },
  { parent: false, value: "IAB19-27", title: "PC Support" },
  { parent: false, value: "IAB19-28", title: "Portable Entertainment" },
  { parent: false, value: "IAB19-29", title: "Shareware/Freeware" },
  { parent: false, value: "IAB19-30", title: "Unix" },
  { parent: false, value: "IAB19-31", title: "Visual Basic" },
  { parent: false, value: "IAB19-32", title: "Web Clip Art" },
  { parent: false, value: "IAB19-33", title: "Web Design/HTML" },
  { parent: false, value: "IAB19-34", title: "Web Search" },
  { parent: false, value: "IAB19-35", title: "Windows" },
  { parent: true,  value: "IAB20",   title: "Travel" },
  { parent: false, value: "IAB20-1", title: "Adventure Travel" },
  { parent: false, value: "IAB20-2", title: "Africa" },
  { parent: false, value: "IAB20-3", title: "Air Travel" },
  { parent: false, value: "IAB20-4", title: "Australia & New Zealand" },
  { parent: false, value: "IAB20-5", title: "Bed & Breakfasts" },
  { parent: false, value: "IAB20-6", title: "Budget Travel" },
  { parent: false, value: "IAB20-7", title: "Business Travel" },
  { parent: false, value: "IAB20-8", title: "By US Locale" },
  { parent: false, value: "IAB20-9", title: "Camping" },
  { parent: false, value: "IAB20-10", title: "Canada" },
  { parent: false, value: "IAB20-11", title: "Caribbean" },
  { parent: false, value: "IAB20-12", title: "Cruises" },
  { parent: false, value: "IAB20-13", title: "Eastern Europe" },
  { parent: false, value: "IAB20-14", title: "Europe" },
  { parent: false, value: "IAB20-15", title: "France" },
  { parent: false, value: "IAB20-16", title: "Greece" },
  { parent: false, value: "IAB20-17", title: "Honeymoons/Getaways" },
  { parent: false, value: "IAB20-18", title: "Hotels" },
  { parent: false, value: "IAB20-19", title: "Italy" },
  { parent: false, value: "IAB20-20", title: "Japan" },
  { parent: false, value: "IAB20-21", title: "Mexico & Central America" },
  { parent: false, value: "IAB20-22", title: "National Parks" },
  { parent: false, value: "IAB20-23", title: "South America" },
  { parent: false, value: "IAB20-24", title: "Spas" },
  { parent: false, value: "IAB20-25", title: "Theme Parks" },
  { parent: false, value: "IAB20-26", title: "Traveling with Kids" },
  { parent: false, value: "IAB20-27", title: "United Kingdom" },
  { parent: true,  value: "IAB21",   title: "Real Estate" },
  { parent: false, value: "IAB21-1", title: "Apartments" },
  { parent: false, value: "IAB21-2", title: "Architects" },
  { parent: false, value: "IAB21-3", title: "Buying/Selling Homes" },
  { parent: true,  value: "IAB22",   title: "Shopping" },
  { parent: false, value: "IAB22-1", title: "Contests & Freebies" },
  { parent: false, value: "IAB22-2", title: "Couponing" },
  { parent: false, value: "IAB22-3", title: "Comparison" },
  { parent: false, value: "IAB22-4", title: "Engines" },
  { parent: true,  value: "IAB23",   title: "Religion & Spirituality" },
  { parent: false, value: "IAB23-1", title: "Alternative Religions" },
  { parent: false, value: "IAB23-2", title: "Atheism/Agnosticism" },
  { parent: false, value: "IAB23-3", title: "Buddhism" },
  { parent: false, value: "IAB23-4", title: "Catholicism" },
  { parent: false, value: "IAB23-5", title: "Christianity" },
  { parent: false, value: "IAB23-6", title: "Hinduism" },
  { parent: false, value: "IAB23-7", title: "Islam" },
  { parent: false, value: "IAB23-8", title: "Judaism" },
  { parent: false, value: "IAB23-9", title: "Latter-Day Saints" },
  { parent: false, value: "IAB23-10", title: "Pagan/Wiccan" },
  { parent: true,  value: "IAB24",   title: "Uncategorized" },
  { parent: true,  value: "IAB25",   title: "Non-Standard Content" },
  { parent: false, value: "IAB25-1", title: "Unmoderated UGC" },
  { parent: false, value: "IAB25-2", title: "Extreme Graphic/Explicit Violence" },
  { parent: false, value: "IAB25-3", title: "Pornography" },
  { parent: false, value: "IAB25-4", title: "Profane Content" },
  { parent: false, value: "IAB25-5", title: "Hate Content" },
  { parent: false, value: "IAB25-6", title: "Under Construction" },
  { parent: false, value: "IAB25-7", title: "Incentivized" },
  { parent: true,  value: "IAB26",   title: "Illegal Content" },
  { parent: false, value: "IAB26-1", title: "Illegal Content" },
  { parent: false, value: "IAB26-2", title: "Warez" },
  { parent: false, value: "IAB26-3", title: "Spyware/Malware" },
  { parent: false, value: "IAB26-4", title: "Copyright Infringement" },
];
